'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = ['M32 416c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C143.4 300.4 160 267.3 160 232l0-104 128 0 0 104c0 15.1-7.1 29.3-19.2 38.4l-57.6 43.2C179 337.8 160 375.7 160 416c0 11 1.4 21.8 4 32c-7.8 6-15.5 11.9-23.3 17.9C129 475 114.4 480 99.5 480L96 480c-35.3 0-64-28.7-64-64zM160 48c0-8.8 7.2-16 16-16l113.6 0c-1 5.2-1.6 10.5-1.6 16l0 48L160 96l0-48zm64 368c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C335.4 300.4 352 267.3 352 232l0-104 128 0 0 184.9c0 24.8-11.5 48.2-31.1 63.3L332.8 465.9C321 475 306.4 480 291.5 480l-3.5 0c-35.3 0-64-28.7-64-64zM352 48c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 48L352 96l0-48z', 'M140.8 465.9C129 475 114.4 480 99.5 480L96 480c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C143.4 300.4 160 267.3 160 232l0-104 128 0 0-32L160 96l0-48c0-8.8 7.2-16 16-16l113.6 0C292 20.2 297 9.4 303.9 .1c-1-.1-2-.1-3-.1L176 0c-26.5 0-48 21.5-48 48l0 184c0 25.2-11.9 48.9-32 64L38.4 339.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96l3.5 0c22 0 43.4-7.3 60.8-20.8l16.1-12.4c-5.4-9.6-9.6-19.9-12.4-30.8c0 0-.1 0-.1 0l-23.2 17.9zM368 0c-26.5 0-48 21.5-48 48l0 184c0 25.2-11.9 48.9-32 64l-57.6 43.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96l3.5 0c22 0 43.4-7.3 60.8-20.8l116.1-89.7c27.4-21.2 43.5-53.9 43.5-88.6L512 48c0-26.5-21.5-48-48-48L368 0zM352 48c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 48L352 96l0-48zm0 80l128 0 0 184.9c0 24.8-11.5 48.2-31.1 63.3L332.8 465.9C321 475 306.4 480 291.5 480l-3.5 0c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l57.6-43.2C335.4 300.4 352 267.3 352 232l0-104z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;